import React from "react";
import ReactSVG from "react-svg";

const Testimonials = (props) => {

  const { caption, name, designation, src } = props.item

  const getStars = () => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(
        <span key={i} className="testimonial-star">
          <i className="fa fa-star"></i>
        </span>
      )
    }
    return stars
  }

  return (
    <div className="register_testimonials">
      <div className="testimonials_sub_container">
        <p className="testimonial_caption">{caption}</p>
        <div className="testimonial_person_card">

          <div>
            <a className="testimonial_name" href={src} target="_blank" rel="noopener noreferrer" >{name}</a>
            <p className="testimonial_designation">{designation}</p>
          </div>
          <div className="g2-container">
            <ReactSVG className="g2-pic" src={require('../../../../static/svg/g2.svg')} />
            {getStars()}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Testimonials
